import React from 'react';
import { Layout } from '../components/Layout/Layout';
import { ProfileCompletionDashboard } from '../components/Analysis/ProfileCompletionDashboard';

export const ProfileAnalysisPage: React.FC = () => {
  return (
    <Layout>
      <div className="p-6">
        <ProfileCompletionDashboard />
      </div>
    </Layout>
  );
};